import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-bold text-infoColor" }, "基本資料")
], -1)
const _hoisted_3 = { class: "justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_time_picker = _resolveComponent("n-time-picker")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_form, {
        model: _ctx.inviteInfo,
        rules: _ctx.rules,
        ref: "formRef",
        "label-placement": "left",
        size: _ctx.size,
        "label-width": 160,
        style: {}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, {
            label: "會議名稱",
            path: "EventName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_input, {
                placeholder: "",
                maxlength: "50",
                "show-count": "",
                value: _ctx.inviteInfo.EventName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inviteInfo.EventName) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_form_item, {
            label: "會議內容",
            path: "EventContext"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_input, {
                placeholder: "",
                value: _ctx.inviteInfo.EventContext,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inviteInfo.EventContext) = $event)),
                type: "textarea",
                autosize: {
            minRows: 3,
            maxRows: 5,
          },
                maxlength: "250",
                "show-count": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_form_item, {
            label: "回覆截止日",
            path: "ReplayDealine"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_date_picker, {
                    type: "date",
                    placeholder: "",
                    "is-date-disabled": _ctx.dateDisabled,
                    value: _ctx.inviteInfo.ReplayDealine,
                    "onUpdate:value": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inviteInfo.ReplayDealine) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.handDatePicker(_ctx.inviteInfo.ReplayDealine)
              ))
                    ],
                    clearable: ""
                  }, null, 8, ["is-date-disabled", "value"]),
                  _createVNode(_component_n_time_picker, {
                    hours: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,],
                    minutes: 30,
                    seconds: [0],
                    value: _ctx.inviteInfo.ReplayDealine,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inviteInfo.ReplayDealine) = $event)),
                    format: "h:mm a"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "size"])
    ])
  ]))
}